import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";
import * as _ from "lodash";
import {Service} from "../../../models/service.model";
import {
  RoutesViewSettingsServicesModel
} from "../../../../routes/models/routes-view-settings.model";
import {
  BringozMenuPanelComponent
} from "../../../../commons/angular/components/bringoz-menu-panel/bringoz-menu-panel.component";
import {PanelService} from "../../../../commons/angular/services/panel.service";
import {
  TaskRelationsPopupComponent,
  TaskRelationsPopupData
} from "../../../../commons/angular/components/task-relations-popup/task-relations-popup.component";
import {TasksHttpService} from "../../../../tasks/angular/services/tasks-http.service";
import {Subscription} from "rxjs";
import {TaskModel} from "../../../../tasks/models/task.model";
import {dedupeRelationsByService, flattenTaskRelations} from "../../../../tasks/utils/task-relations.util";
import {TaskPurposeType} from "../../../../commons/types/task-purpose.type";
import {TaskRelationModel} from "../../../../tasks/models/task-relation.model";

require('./services-panel-list-item.scss');
@Component({
  standalone: false,
  selector: 'app-services-panel-list-item',
  templateUrl: './services-panel-list-item.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServicesPanelListItemComponent implements OnInit, OnChanges {

  @Input() service: Service;
  @Input() isSelected: boolean;
  @Input() settings: RoutesViewSettingsServicesModel;
  @Input() itemElementSize: string;
  @Output() onViewJob = new EventEmitter<boolean>();
  @Output() onToggle = new EventEmitter<boolean>();
  @Output() onSplitByPackages = new EventEmitter<{ item: Service | TaskModel; event: MouseEvent }>();
  @Output() onDrillDown = new EventEmitter<{ routeId: string; event: any }>();

  public isHover: boolean;
  public routeColor: string;
  public serviceTags: string[];
  public relations: TaskRelationModel[];

  private _isSplitAllowed: boolean = false;
  private _contextMenuSubscription: Subscription;

  constructor(
    @Inject('$timeout') private $timeout,
    @Inject('planningCommonService') private planningCommonService,
    @Inject(PanelService) private panelService: PanelService,
    @Inject('servicesService') private servicesService,
    @Inject(TasksHttpService) private tasksHttpService: TasksHttpService,
  ) {}

  ngOnInit() {
    this._setServiceTags();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.service) {
      this._isSplitAllowed = this.servicesService.isSplitAllowedForStatus(this.service.status)
      this.relations = dedupeRelationsByService(flattenTaskRelations(this.service.taskList), TaskPurposeType.Dropoff);
    }
  }

  onRelationsClick(event: MouseEvent) {
    const taskIds = _.map(this.service.taskList, 'id');
    this.panelService.open<TaskRelationsPopupComponent>(TaskRelationsPopupComponent, event, {
      relations: this.relations,
      tasks$: this.tasksHttpService.getTasks(taskIds)
    } as TaskRelationsPopupData);
  }

  onToggleEvent($event) {
    this.onToggle.emit(!this.isSelected)
  }

  onRouteIdClick(event: any, routeId: string) {
    event.stopPropagation();
    this.onDrillDown.emit({ routeId, event });
  }

  onHover(isHover) {
    this.isHover = isHover;
    this.$timeout(0).then(() => {});
  }

  private _setServiceTags() {
    this.serviceTags = [];

    if (!!this.service.tagNames?.length) {
      this.serviceTags = this.serviceTags.concat(this.service.tagNames);
    }

    if (!!this.service.accountReference?.tags?.length) {
      this.serviceTags = this.serviceTags.concat(this.service.accountReference.tags);
    }
  }

  onRightClick(event: MouseEvent) {
    event.preventDefault();
    const panel = this.panelService.open(BringozMenuPanelComponent, event, [
      {
        name: 'Split Packages',
        action: 'splitByPackages',
        iconName: 'BOX',
        disabled: !this._isSplitAllowed,
      }], {
      position: {
        originX: 'center',
        originY: 'top',
        overlayX: 'start',
        overlayY: 'top',
      },
      width: 130
    });

    if (panel) {
      if (this._contextMenuSubscription) {
        this._contextMenuSubscription.unsubscribe();
      }

      this._contextMenuSubscription = panel.instance.onClose
        .subscribe((action?: string) => {
          switch (action) {
            case 'splitByPackages':
              this.onSplitByPackages.emit({ item: this.service, event: event });
              break;
            default:
              break;
          }

          this._contextMenuSubscription?.unsubscribe();
        });
    }
  }
}
